import React from 'react';
import IconSwitch from '../../../../shared/iconSwitch/iconSwitch';
import { makeStyles, useTheme, Divider } from '@material-ui/core';
import { styles } from './sideNavFooter.styles';

// import logo from '../../../../../assets/images/globalerisLogo.png';
// import logoIcon from '../../../../../assets/images/globalerisLogoIcon.png';
import IconBadgeExpandable from '../../../../iconBadgeExpandable/iconBadgeExpandable';
import { useSelector } from 'react-redux';
import { RootStoreModel } from '../../../../../redux/store.model';
import { ConfigurationDialog } from './configurationDialog';

export interface SideNavFooterProps {
  open: boolean;
}

const SideNavFooter: React.FC<SideNavFooterProps> = ({ open = false }) => {
  const currentTheme = useTheme();
  const useStyles = makeStyles(styles(currentTheme));
  const classes = useStyles();

  const company = useSelector(
    (state: RootStoreModel) => state.profile.activeCompany && state.profile.activeCompany
  );

  const balanceZone = useSelector(
    (state: RootStoreModel) => state.profile.activeBalanceZone && state.profile.activeBalanceZone
  );

  const [showConfiguration, setShowConfiguration] = React.useState<boolean>(false);

  const handleShowConfiguration = React.useCallback(
    (show: boolean) => {
      setShowConfiguration(show);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [showConfiguration]
  );

  return (
    <>
      {company && balanceZone ? (
        <div className={classes.sideNavFooter}>
          <Divider />
          <IconBadgeExpandable
            faIcon="building"
            expanded={open}
            name={company !== undefined ? company.description : ''}
            abbreviation={company !== undefined ? company.abbreviation : ''}
            onClick={() => handleShowConfiguration(true)}
            tooltip={'Pulse para modificar la configuracion'}
          />
          <IconBadgeExpandable
            faIcon="compass"
            expanded={open}
            name={balanceZone !== undefined ? balanceZone.description : ''}
            abbreviation={balanceZone !== undefined ? balanceZone.code : ''}
            onClick={() => handleShowConfiguration(true)}
            tooltip={'Pulse para modificar la configuracion'}
          />
          <div></div>
          {/* <IconSwitch open={open} collapseImage={logoIcon} expandImage={logo} /> */}
          {showConfiguration && (
            <ConfigurationDialog
              open={showConfiguration}
              onClose={() => handleShowConfiguration(false)}
            ></ConfigurationDialog>
          )}
        </div>
      ) : null}
    </>
  );
};

export default React.memo(SideNavFooter);
